var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        { staticClass: "headline" },
        [
          _c("v-icon", [_vm._v("check")]),
          _vm._v("\n    Aprobar Movilidad\n    "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.close()
                }
              }
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-container",
            { attrs: { "grid-list-md": "" } },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c("v-flex", { attrs: { md12: "" } }, [
                    _c("strong", [_vm._v("Tipo de movilidad:")]),
                    _vm._v(
                      " " + _vm._s(_vm.movilidad.tipo_movimiento) + "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { md12: "" } }, [
                    _c("strong", [_vm._v("Funcionario:")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.movilidad.funcionario.nombre) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { md6: "" } }, [
                    _c("strong", [_vm._v("Item:")]),
                    _vm._v(" " + _vm._s(_vm.movilidad.nro_item) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { md6: "" } }, [
                    _c("strong", [_vm._v("Fecha desde:")]),
                    _vm._v(" " + _vm._s(_vm.movilidad.fecha_desde) + "\n      ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { color: "success", loading: _vm.loading },
              on: {
                click: function($event) {
                  return _vm.aprobarRechazar(1)
                }
              }
            },
            [_c("v-icon", [_vm._v("check")]), _vm._v(" Aprobar\n  ")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { color: "error", loading: _vm.loading },
              on: {
                click: function($event) {
                  return _vm.aprobarRechazar(0)
                }
              }
            },
            [_c("v-icon", [_vm._v("clear")]), _vm._v(" Rechazar\n  ")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f882c66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f882c66","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/persona/components/AprobarCambioItem.vue
// module id = null
// module chunks = 